module.exports = __webpack_public_path__ + "img/syl_main0.85181659.jpg";